import { Mission } from "@types";
import axiosBaseApi from '../axiosBaseApi';

export const getMission = async (id: number): Promise<{ mission: Mission } | undefined> => {
  try {
    return await axiosBaseApi.get(`/missions/${id}`);
  } catch (error) {
    console.error('Error get mission:', error);
  }
}